module.exports = __webpack_public_path__ + "img/icon-edit-amount.88990320.svg";